import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmReportsCustomCreateRoute: InvariantJiraRoute = {
	name: 'csm-reports-custom-create',
	path: '/jira/customer-service-management/projects/:projectKey/reports/custom/new',
};
